import { isAbortError } from './isAbortError'

interface AxiosErrorLike {
  isAxiosError?: boolean
  response?: unknown
  code?: string
}

export default function isNotAnonAxiosError(err: unknown): boolean {
  // Filter out AbortErrors from navigation-based request cancellation
  if (isAbortError(err)) {
    return false
  }

  const axiosErr = err as AxiosErrorLike

  if (!('isAxiosError' in axiosErr) && !axiosErr.isAxiosError) {
    return true
  }

  if (
    ('response' in axiosErr && axiosErr.response) ||
    ('code' in axiosErr && axiosErr.code)
  ) {
    return true
  } else {
    return false
  }
}
